// import { HttpStatusCode } from "axios";
// import { UserManager } from "oidc-client-ts";

import axiosInstance from "@/common/axiosInstance";
// import { appConfig } from "@/common/config";

// const userManager = new UserManager(appConfig.settings);

const apiCall = async (method: 'get' | 'post', url: string, data?: any) => {
    try {
        const response = await axiosInstance[method]<any>(url, data);
        return response.data;
    } catch (err: any) {
        // if (err?.status === HttpStatusCode.Unauthorized) { // || err.code === 'ERR_NETWORK') {
        //     setTimeout(async () => {
        //         await userManager.clearStaleState();
        //         await userManager.signoutRedirect();
        //     }, 2000);
        // }

        return {
            status: err?.status,
            message: err?.response?.data?.message || err?.message
        };
    }
};

export default apiCall;